import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { getTeamResult } from '../../../API/repositories/reports';
import { Colors } from '../../../common/colors/colors';
import Loading from '../../../common/components/Loading';
import TeamLeaderProductSelect, {
	useTeamSuperProductFilter,
} from '@/common/components/TeamLeaderProductSelect';
import { useRequestsContext } from '../../../common/hooks/requestHook';
import { SearchBarCenter } from '@/common/styles/SearchBars';
import { Page, TableWrapper, Wrapper } from './ConsultantTeamLastResult.styled';

const groupResultsByDate = (rows) => {
	const groups = [];

	rows.forEach((row) => {
		const lastGroup = groups[groups.length - 1];

		if (lastGroup && lastGroup.date === row.index) {
			lastGroup.rows.push(row);
			return;
		}

		groups.push({ date: row.index, rows: [row] });
	});

	return groups;
};

const sumResultField = (rows, field) =>
	rows.reduce((total, row) => total + (row[field] || 0), 0);

const ConsultantTeamLastResult = () => {
	const [results, setResult] = useState(null);
	const [selectedProduct, setSelectedProduct] = useState(null);

	const { hasUnfilledRequest, makeRequest } = useRequestsContext();
	const { getProductIds } = useTeamSuperProductFilter();
	const from = moment().subtract('14', 'days').format('DD/MM/YYYY');
	const to = moment().format('DD/MM/YYYY');

	const getTeamRsults = async () => {
		const payload = {};

		if (selectedProduct?.value) {
			const productIds = getProductIds(selectedProduct.value);

			if (!productIds.length) {
				setResult([]);
				return;
			}

			payload.products = productIds;
		}

		setResult(null);

		const response = await makeRequest(getTeamResult.bind(null, payload));

		if (response?.data) {
			setResult(response.data);
		}
	};

	useEffect(() => {
		getTeamRsults();
	}, [selectedProduct]);

	return (
		<Page>
			{hasUnfilledRequest(getTeamResult) && <Loading />}
			<SearchBarCenter>
				<TeamLeaderProductSelect
					selected={selectedProduct}
					setSelected={setSelectedProduct}
					width={150}
				/>
			</SearchBarCenter>
			<Wrapper>
				{results &&
					results.map((consultantData) => (
						<TableWrapper key={consultantData.username}>
							<h5
								style={{
									textAlign: 'center',
									marginBottom: '10px',
									color: Colors.darkBlue,
								}}
							>
								{consultantData.username} ( {from} - {to})
							</h5>
							<table className='styled-table'>
								<thead>
									<tr>
										<th>Date</th>
										<th>Product</th>
										<th>Confirmed</th>
										<th> Delivered</th>
										<th>Confirmed more than 1 item</th>
										<th>Delivered more than 1 item</th>
									</tr>
								</thead>
								<tbody className='queue'>
									{groupResultsByDate(consultantData.result).map((group) =>
										group.rows.map((result, rowIndex) => (
											<tr key={group.date + '_' + result.product}>
												{rowIndex === 0 && (
													<td
														rowSpan={group.rows.length}
														style={{ verticalAlign: 'middle' }}
													>
														{group.date}
													</td>
												)}
												<td>{result.product}</td>
												<td>{result.confirmed}</td>
												<td>{result.delivered}</td>
												<td>{result.confirmedMoreOneProduct}</td>
												<td>{result.deliveredMoreOneProduct}</td>
											</tr>
										)),
									)}
									<tr>
										<td>Total</td>
										<td />
										<td>
											{sumResultField(consultantData.result, 'confirmed')}
										</td>
										<td>
											{sumResultField(consultantData.result, 'delivered')}
										</td>
										<td>
											{sumResultField(
												consultantData.result,
												'confirmedMoreOneProduct',
											)}
										</td>
										<td>
											{sumResultField(
												consultantData.result,
												'deliveredMoreOneProduct',
											)}
										</td>
									</tr>
								</tbody>
							</table>
						</TableWrapper>
					))}
			</Wrapper>
		</Page>
	);
};

export default ConsultantTeamLastResult;
